export const MAP_PATH = './data/'
export const MAP_ID = 'TJ00001'

// 模型地址
export const MODEL_PATH = MAP_PATH + MAP_ID + '/codeModel/'
export const BOATS_MODEL_PATH = MODEL_PATH + '';
export const CHACHE_MODEL_PATH = MODEL_PATH + '';

// 图片地址
export const IMAGE_PATH = './image/'

// 瓦片源地址
export const TILE_URL = 'https://webst02.is.autonavi.com/appmaptile?style=7&x=${x}&y=${y}&z=${z}' // 瓦片图服务地址
